import React from "react";
import { SEO, DynamicScript } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import "../style/book-now.css";

export default class BookNowPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.prestigebeautywellness.com/book-now/"}
        />
        <Grid
          className={"custom-page-book-now custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"qbojnqgxtkxewkwo"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"ktfmfqrnuffahnhk"}
              style={{ padding: 16 }}
              width={14}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__2bfbb2c0-e751-449d-adc9-cca758a5aaa0"}
                >
                  <div>
                    <div className={"meevo-booking-wrapper"}>
                      <div
                        className={"meevo-booking-loading"}
                        id={"meevoLoader"}
                      >
                        <div className={"meevo-booking-spinner"} />
                      </div>
                      <iframe
                        id={"meevoBookingFrame"}
                        referrerpolicy={"no-referrer-when-downgrade"}
                        src={
                          "https://na1.meevo.com/CustomerPortal/onlinebooking?tenantId=200239"
                        }
                        title={
                          "Book an Appointment — Prestige Beauty &amp; Wellness"
                        }
                        loading={"eager"}
                        allow={"payment; geolocation; clipboard-write"}
                      />
                    </div>
                    <DynamicScript
                      type={"application/javascript"}
                      delay={300}
                      body={
                        "(function () {var frame = document.getElementById('meevoBookingFrame');var loader = document.getElementById('meevoLoader');frame.addEventListener('load', function () {loader.classList.add('hidden');});setTimeout(function () {loader.classList.add('hidden');}, 6000);})();"
                      }
                    />
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 30352 }) {
      title
      seoTitle
      description
    }
  }
`;
